<ins-scene-container [sceneMode]="sceneMode" [openedPanel]="openedPanel" ></ins-scene-container>
